export enum SimulationType {
    Time,
    Battery
}

export enum SortType {
    Time,
    Battery,
    Price
}